import { Box, Typography } from "@mui/material";
import countryList from "country-list";
import { getFlagUrl } from "../../../shared/utils";
import { Fragment } from "react";

export function ReadOnlyCountries({ code }: { code?: string | Array<string> }) {
  if (!code) {
    return (
      <Typography
        id="solution-name-no-country"
        align="left"
        sx={{ paddingBottom: 1 }}
        variant="subtitle2"
      >
        No country set
      </Typography>
    );
  }

  if (typeof code === "string") {
    return (
      <Box
        id="solution-country-container"
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "start",
          alignItems: "center",
          paddingBottom: 1,
        }}
      >
        <img
          style={{ border: "1px solid black" }}
          loading="lazy"
          width="32"
          src={getFlagUrl(code)}
          alt={`country flag for ${code}`}
        />
        <Typography
          sx={{ paddingLeft: 1 }}
          id="solution-name-country"
          align="left"
        >
          {countryList.getName(code) || code}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      id="solution-country-container"
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "start",
        alignItems: "center",
        paddingBottom: 1,
      }}
    >
      {code.map((c, index) => (
        <Fragment key={`${c}-${index}`}>
          <img
            style={{ border: "1px solid black" }}
            key={`${c}-image`}
            loading="lazy"
            width="32"
            src={getFlagUrl(c)}
            alt={`country flag for ${c}`}
          />
          <Typography
            key={`${c}-title`}
            sx={{ paddingLeft: 1, paddingRight: 1 }}
            id="solution-name-country"
            align="left"
          >
            {countryList.getName(c) || c}
          </Typography>
        </Fragment>
      ))}
    </Box>
  );
}
